<script>
  export default {
    functional: true,
    props: {
      content: {
        type: [Object],
        default: () => {},
      },
    },
    render(h, ctx) {
      return ctx.props.content
    }
  }
</script>
